import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  CircularProgress,
  Box,
  MenuItem,
} from '@mui/material';
import { Link } from 'react-router-dom';
import CustomerSupportSideBar from '../../../../../layouts/customer-support/CustomerSupportSideBar';
import Logout from '../../../../shared/auth/Logout';
import { API_URL, customer_support } from '../../../../../../utils/config';
import mail from '../../../../../../assets/img/icons/mailblast.svg';
import toastr from 'toastr';
export default function NewCallLog() {
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedLog, setSelectedLog] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [search, setSearch] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    cin: '',
  });
  const [form, setForm] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    cin: '',
    issue: '',
    resolution: '',
    note: '',
    zone: '',
    zohoDepartment: '',
    zohoDepartmentId: '',  // Add this back
    zohoContactId: '',     // Add this back
  });
  const [formLoading, setFormLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [zones, setZones] = useState([]);
  const [loadingZones, setLoadingZones] = useState(false);

  const resolutionOptions = [
    { value: "technical_visit", label: "Technical Visit" },
    { value: "assisted", label: "Assisted" },
    { value: "expired", label: "Expired" },
    { value: "escalated_to_account", label: "Escalated to Account" },
    { value: "downtime", label: "Downtime" },
    { value: "dropped", label: "Dropped" },
    { value: "escalated_to_retension", label: "Escalated to Retention" },
    { value: "escalated_to_sales", label: "Escalated to Sales" },
    { value: "advised_to_send_an_email", label: "Advised to Send Email" },
    { value: "escalated_to_NOC", label: "Escalated to NOC" },
    { value: "troubleshoot", label: "Troubleshoot" },
    { value: "call_back", label: "Call Back" },
    { value: "unable_to_get_account", label: "Unable to Get Account" }
  ];

  const zohoDepartments = [
    { value: "TIZETI NETWORK LIMITED", label: "TIZETI NETWORK LIMITED" },
    { value: "NOC DEPARTMENT", label: "NOC DEPARTMENT" },
    { value: "HUMAN RESOURCES", label: "HUMAN RESOURCES" },
    { value: "ACCOUNT DEPARTMENT", label: "ACCOUNT DEPARTMENT" },
    { value: "FREE FIBER", label: "FREE FIBER" },
    { value: "SALES DEPARTMENT", label: "SALES DEPARTMENT" },
    { value: "RESEARCH AND DEVELOPMENT DEPARTMENT", label: "RESEARCH AND DEVELOPMENT DEPARTMENT" }
  ];

  const role = sessionStorage.getItem('roleId');
  const user = sessionStorage.getItem('firstName');
    
  useEffect(() => {
    fetchLogs();
    // eslint-disable-next-line
  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchZones();
  }, []);
  
  const fetchLogs = async () => {
    setLoading(true);
    try {
      const params = {
        name: search.name || '',
        email: search.email || '',
        phoneNumber: search.phoneNumber || '',
        cin: search.cin || '',
        limit: rowsPerPage,
        page: page + 1,
      };
      const queryString = Object.entries(params)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const response = await axios.get(
        `https://api.tizeti.com/api/v1/customercallLognew?${queryString}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          },
        },
      );
      setLogs(response.data.list);
      setTotalCount(response.data.count);
    } catch (error) {
      console.error('Error fetching logs:', error);
    }
    setLoading(false);
  };

  const fetchZones = async () => {
    setLoadingZones(true);
    try {
      const response = await axios.get(
        'https://api.tizeti.com/api/v1/zones',
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          },
        }
      );
      setZones(response.data);
    } catch (error) {
      console.error('Error fetching zones:', error);
    }
    setLoadingZones(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleViewMore = (log) => {
    setSelectedLog(log);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSearchChange = (e) => {
    setSearch({ ...search, [e.target.name]: e.target.value });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(0);
    fetchLogs();
  };

  const handleOpenAddModal = () => {
    setForm({
      name: '',
      email: '',
      phoneNumber: '',
      cin: '',
      issue: '',
      resolution: '',
      note: '',
      zone: '',
      zohoDepartment: '',
      zohoDepartmentId: '',
      zohoContactId: '',
    });
    setAddModalOpen(true);
  };

  const handleCloseAddModal = () => {
    setAddModalOpen(false);
  };

  const handleFormChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAddLog = async (e) => {
    e.preventDefault();
    setFormLoading(true);
    try {
      // Set CIN to "N/A" if empty
      const formData = {
        ...form,
        cin: form.cin || "N/A",
        complaint_type: form.resolution, 
        basestation: form.zone, 
        zohoDepartmentId: form.zohoDepartment
      };
      
      await axios.post(
        'https://api.tizeti.com/api/v1/customercallLognew',
        formData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          },
        },
      );
      setFormLoading(false);
      setAddModalOpen(false);
      fetchLogs();
    } catch (error) {
      setFormLoading(false);
      toastr.error('Error adding log');
    }
  };

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <div className="d-flex col-lg-12 p-2 top-header">
          <div className="mt-3 d-flex col-lg-12 p-0">
            {/* <Link className="s-sidebar__trigger" to={"#"}>
                                <i className="fa fa-bars mr-3"></i>
                            </Link> */}
            <CustomerSupportSideBar role={role} />

            <h3 className="col-md-5 overview-part">Call Log</h3>

            <div className="ml-5 d-flex profile-mail">
              <Link
                to="/technical-support/mail-blast"
                className="d-none d-md-flex"
                style={{
                  color: 'gray',
                  textDecoration: 'none',
                }}
              >
                {/* <Link to={"/sales/mail-blast"} className="d-flex" style={{ color: "gray", textDecoration: "none" }}> */}
                <img src={mail} alt="" className="logout mr-2" />
                <span>
                  <h6 className="m-2">
                    <strong>MailBlast</strong>
                  </h6>
                </span>
              </Link>

              <h6 className="mr-0 d-flex">
                <i className="small mr-2 d-none d-md-block">{user}</i>
                <Logout />
              </h6>
            </div>
          </div>
        </div>

        <div className="container mt-8" style={{marginTop: '8rem'}}>
          {/* Search Form */}
          <form onSubmit={handleSearch} style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
            <TextField
              name="name"
              label="Name"
              value={search.name}
              onChange={handleSearchChange}
              size="small"
              variant="outlined"
            />
            <TextField
              name="email"
              label="Email"
              value={search.email}
              onChange={handleSearchChange}
              size="small"
              variant="outlined"
            />
            <TextField
              name="phoneNumber"
              label="Phone Number"
              value={search.phoneNumber}
              onChange={handleSearchChange}
              size="small"
              variant="outlined"
            />
            <TextField
              name="cin"
              label="CIN"
              value={search.cin}
              onChange={handleSearchChange}
              size="small"
              variant="outlined"
            />
            <Button
              type="submit"
              variant="contained"
              sx={{ bgcolor: '#3bb427;', color: '#fff', '&:hover': { bgcolor: '#21a1f3' } }}
            >
              Search
            </Button>
          </form>
          <Button
            variant="contained"
            onClick={handleOpenAddModal}
            sx={{ mb: 2, bgcolor: '#3bb427;', color: '#fff', '&:hover': { bgcolor: '#21a1f3' } }}
          >
            Add New Log
          </Button>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
              <CircularProgress sx={{ color: '#3bb427;' }} />
            </Box>
          ) : (
            <TableContainer component={Paper} sx={{marginTop: '2rem'}}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>S/N</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Phone Number</TableCell>
                    <TableCell>CIN</TableCell>
                    <TableCell>Issue</TableCell>
                    <TableCell>Resolution</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Note</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {logs.map((log, idx) => (
                    <TableRow key={log.id}>
                      <TableCell>{page * rowsPerPage + idx + 1}</TableCell>
                      <TableCell>{log.name}</TableCell>
                      <TableCell>{log.email}</TableCell>
                      <TableCell>{log.phoneNumber}</TableCell>
                      <TableCell>{log.cin}</TableCell>
                      <TableCell>{log.issue}</TableCell>
                      <TableCell>{resolutionOptions.find(item => item.value === log.resolution).label}</TableCell>
                      <TableCell>{new Date(log.created_at).toLocaleDateString()}</TableCell>
                      <TableCell>{log.note}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          <TablePagination
            component="div"
            count={totalCount}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          {/* View More Dialog */}
          <Dialog open={openModal} onClose={handleCloseModal} maxWidth="xs" fullWidth>
            <DialogTitle>Log Details</DialogTitle>
            <DialogContent dividers>
              {selectedLog && (
                <>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Name: <strong>{`${selectedLog.firstName} ${selectedLog.lastName}`}</strong>
                  </Typography>
                  <Typography variant="body2">Email: {selectedLog.email}</Typography>
                  <Typography variant="body2">Phone: {selectedLog.phoneNumber}</Typography>
                  <Typography variant="body2">Date: {new Date(selectedLog.created_at).toLocaleDateString()}</Typography>
                  <Typography variant="body2">Note: {selectedLog.note}</Typography>
                  {/* <Typography>Address: {selectedLog.address}</Typography> */}
                </>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleCloseModal}
                sx={{ bgcolor: '#3bb427;', color: '#fff', '&:hover': { bgcolor: '#21a1f3' } }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>

          {/* Add New Log Dialog */}
          <Dialog open={addModalOpen} onClose={handleCloseAddModal} maxWidth="sm" fullWidth>
            <DialogTitle>Add New Call Log</DialogTitle>
            <form onSubmit={handleAddLog}>
              <DialogContent dividers>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {/* Customer Information Section */}
                  <Typography variant="subtitle2" sx={{ mt: 1, mb: 1, fontWeight: 'bold' }}>
                    Customer Information
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField
                      name="name"
                      label="Name"
                      value={form.name}
                      onChange={handleFormChange}
                      required
                      fullWidth
                      margin="dense"
                      size="small"
                    />
                    <TextField
                      name="email"
                      label="Email"
                      value={form.email}
                      onChange={handleFormChange}
                      required
                      fullWidth
                      margin="dense"
                      size="small"
                      type="email"
                    />
                  </Box>
                  
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField
                      name="phoneNumber"
                      label="Phone Number"
                      value={form.phoneNumber}
                      onChange={handleFormChange}
                      required
                      fullWidth
                      margin="dense"
                      size="small"
                    />
                    <TextField
                      name="cin"
                      label="CIN"
                      value={form.cin}
                      onChange={handleFormChange}
                      fullWidth
                      margin="dense"
                      size="small"
                    />
                  </Box>
                  
                  {/* Case Details Section */}
                  <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                    Case Details
                  </Typography>
                  <TextField
                    name="issue"
                    label="Issue"
                    value={form.issue}
                    onChange={handleFormChange}
                    required
                    fullWidth
                    margin="dense"
                    size="small"
                  />
                  <TextField
                    name="resolution"
                    label="Resolution"
                    value={form.resolution}
                    onChange={handleFormChange}
                    required
                    select
                    fullWidth
                    margin="dense"
                    size="small"
                    SelectProps={{
                      MenuProps: {
                        style: { maxHeight: 300 },
                      },
                    }}
                  >
                    {resolutionOptions.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  
                  <TextField
                    name="note"
                    label="Note"
                    value={form.note}
                    onChange={handleFormChange}
                    fullWidth
                    margin="dense"
                    size="small"
                    multiline
                    minRows={5}  // Increased from 3 to 5
                    sx={{ '& .MuiInputBase-root': { minHeight: '120px' } }}  // Added height styling
                  />
                  
                  {/* Additional Information Section */}
                  <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                    Additional Information
                  </Typography>
                  
                  <TextField
                    name="zone"
                    label="Zone"
                    value={form.zone}
                    onChange={handleFormChange}
                    select
                    fullWidth
                    margin="dense"
                    size="small"
                    SelectProps={{
                      MenuProps: {
                        style: { maxHeight: 300 },
                      },
                    }}
                    disabled={loadingZones}
                  >
                    {loadingZones ? (
                      <MenuItem disabled>Loading zones...</MenuItem>
                    ) : (
                      zones.map(zone => (
                        <MenuItem key={zone.id} value={zone.id}>
                          {zone.name}
                        </MenuItem>
                      ))
                    )}
                  </TextField>
                  
                  <TextField
                    name="zohoDepartment"
                    label="Zoho Department"
                    value={form.zohoDepartment}
                    onChange={handleFormChange}
                    select
                    fullWidth
                    margin="dense"
                    size="small"
                  >
                    {zohoDepartments.map(dept => (
                      <MenuItem key={dept.value} value={dept.value}>
                        {dept.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  
                  {/* Add these fields back */}
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField
                      name="zohoDepartmentId"
                      label="Zoho Department ID (Optional)"
                      value={form.zohoDepartmentId}
                      onChange={handleFormChange}
                      fullWidth
                      margin="dense"
                      size="small"
                    />
                    <TextField
                      name="zohoContactId"
                      label="Zoho Contact ID (Optional)"
                      value={form.zohoContactId}
                      onChange={handleFormChange}
                      fullWidth
                      margin="dense"
                      size="small"
                    />
                  </Box>
                </Box>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleCloseAddModal}
                  disabled={formLoading}
                  sx={{ bgcolor: '#3bb427;', color: '#fff', '&:hover': { bgcolor: '#21a1f3' } }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={formLoading}
                  sx={{ bgcolor: '#3bb427;', color: '#fff', '&:hover': { bgcolor: '#21a1f3' } }}
                >
                  {formLoading ? 'Adding...' : 'Add Log'}
                </Button>
              </DialogActions>
            </form>
          </Dialog>
        </div>
      </main>
    </div>
  );
}
